import { LitElement, html, css } from '@polymer/lit-element'
import {anchorRoute, gotoRoute} from '../Router'
import Auth from '../Auth'
import App from '../App'

customElements.define('va-app-header-blk', class AppHeader extends LitElement {
  constructor(){
    super()    
  }

  static get properties(){
    return {
      title: {
        type: String
      },
      user: {
        type: Object
      }
    }
  }

  firstUpdated(){
    super.firstUpdated()
    this.navActiveLinks()    
  }

  navActiveLinks(){	
    const currentPath = window.location.pathname
    const navLinks = this.shadowRoot.querySelectorAll('.app-top-nav a, .app-side-menu-items a')
    navLinks.forEach(navLink => {
      if(navLink.href.slice(-1) == '#') return
      if(navLink.pathname === currentPath){			
        navLink.classList.add('active')
      }
    })
  }

  

  render(){    
    return html`
    <style>      
    * {
      box-sizing: border-box;
    }
    .app-header {
      background: transparent;
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      height: var(--app-header-height);
      display: flex;
      z-index: 9;
      align-items: center;
    }
    

    .app-header-main {
      
     
      width: 100px;
      margin-left:7%;
      
    }

    .logo{
      width:100%;
    }


    


    .app-top-nav {
      display: flex;
      
      width: 70%;
      height: 100%;
      align-items: center;
      margin-left: 15%;
    
      
      
    }

    .links{
     
      position: absolute;
      right: 0;
     
    }

    .app-top-nav a {
      display: inline-block;
      padding: 3em;
      text-decoration: none;
      font-size: 16px;
      font-weight: 500;
      
      color: #3A3A3A;
      
    }
    

    /* active nav links */
    .app-top-nav a.active
    {
      font-weight: bold;
      color: var(--brand-color);



  
  
    }  
    
    
    
   /* RESPONSIVE DESKTOP LOWER res -----------------*/
      @media all and (max-width: 1024px){       
      
        .app-top-nav a{
          padding: 2em;
        }
          
        
      }

    /* RESPONSIVE - MOBILE ------------------- */
    @media all and (max-width: 768px){       
      
      .app-top-nav {
        display: none;
      }
    }

  </style>

  <header class="app-header">
    
    
    <div class="app-header-main">
    
      <img class="logo" src="/images/logo-blk.svg">
  
    </div>

    <nav class="app-top-nav">
        <div class="links">
                ${(this.user.accessLevel==2)? html`<a href="/activejobs" @click="${anchorRoute}">ACTIVE JOBS</a>`:html`` } 
                <a href="/" @click="${anchorRoute}">HOME</a>  
                <a href="/hiredworkers" @click="${anchorRoute}">HIRED WORKERS</a> 
                ${(this.user.accessLevel==2)? html` <a href="/providerprofile" @click="${anchorRoute}">PROFILE</a>`:html`<a href="/profile" @click="${anchorRoute}">PROFILE</a>` }  
                <a href="#"  @click="${() => Auth.signOut()}"">LOGOUT</a>   
        <div>
      

            
      
    </nav>
  </header>

  

    
    `
  }
  
})

